var _desc, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMassageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_1_32690",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_3269_0",
    transform: "matrix(0.01,0,0,0.01,0.28,0.28)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image1_3269_0",
    width: 44,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAABHNCSVQICAgIfAhkiAAAAmFJREFUWIXtmE1O21AQgL/3yKLLBGilruoLFB43MCdoOQFwgvYASB6fADhB4QbtDXKDOrDosmaF1NaQfWtPF2mRCSZ++XOMxLeKRpPMp6fxzIsNJZz8DBW7DyYEDVgpZgj62ZCfJvIquYv+/+AkO1H4sBq5yRiIE9kQAAvgJJO2ygIoRFuSHQMYJz+csvZ11VI+GIrdjrJWcbLaV7N21rjRHUXXKA44KEcVu98B3o9lnw1k87AptUlsy00AGpZCoQW65SQ1JLSEguJ8LBTYh2k6bMRmRiqE282z8LLp+CQ5yT4qJgLt1mfPgkkNeprIxkldZu0JO7ntKhwvTxZAA4VjJ7e1NXxaYomi4/wO6jJqhRPppWD6C7CpLVW+lT2GVw8PZH33bXz7zizxtC+i3viSqMRLGOAy6n2ZXWdxPLmx9uSEvVvCyXUAnWD6Ejr0eZh88V0cohDNWmRbbpKBrO/M+v0yPosjmEd2hLqt+Nf+fL8xorEeVljItdVrcahB5iuj/ctocyFj0auHL6KN2Mn1eW5fvJm2wB9L+u2odzW9WjXeUyKR1ymQLqrwrDy5OfwsvGwsY+PGqAlXo+JHB0wy9rLiwEl2BUW/QY10dO/2yDTksWLDcnC02eyc220aCpxkd28oJ2ETedlv6B/FRBQiJ5nU5VkAg9kbtcZq8ZG2AIn0hgNZ3ynID1nxcqiTNlVBJ9+7ue1uL82qLKBFaPThXcVAnKOpxXwai6+erTiLqqT/TTB3L9KQUy2PS9+nNcLgJ90qYaiXbp0wTJZupTA8Lt1aYaiUTlstDPekU0O+9xfwtNWoAL4tMQAAAABJRU5ErkJggg=="
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Link",
    rx: 24.5,
    width: 49,
    height: 49,
    transform: "translate(0.500000 0.500000)",
    fill: "url(#pattern_1_32690)",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMassageIcon);
export default __webpack_public_path__ + "static/media/sendMassageIcon.e9e314d0a2a90e3dd8bf35bae78c7bd0.svg";
export { ForwardRef as ReactComponent };